import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { hasModulePermission } from "../../utils/permissionUtils";

interface ProtectedRouteProps {
  moduleName: string;
  action?: "read" | "write" | "update" | "upload" | "delete";
  children: ReactNode;
}

const ProtectedRoute = ({ moduleName, action = "read", children }: ProtectedRouteProps) => {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  const allowed = hasModulePermission(user, moduleName, action);
  if (!allowed) return <Navigate to="/unauthorized" replace />;

  return <>{children}</>;
};

export default ProtectedRoute;
